import type { ReactNode } from "react";
import type { FieldError } from "react-hook-form";

export function FormFieldErrors({ errors }: { errors: ReactNode[] }) {
    if (errors.length === 0) {
        return null;
    }

    const messages = errors.map((error, i) => (
        <div key={i} className="react-aria-FieldError">
            {error}
        </div>
    ));

    return messages;
}

export function RhfError({ error }: { error: FieldError | undefined }) {
    return error != null && <FormFieldErrors errors={[error.message]} />;
}
